import styled from "styled-components";
import { fHeader, fHeaderSm } from "../../styles/global";

export const SubNav = styled.div`
  ${fHeaderSm}

  a {
    line-height: 1.3;

    &.active,
    &:hover {
      ${"" /* background-image: linear-gradient(
        to right,
        currentColor 100%,
        currentColor 0
      );
      background-size: 1px 1px;
      background-position: 0 0.89em;
      background-repeat: repeat-x; */}
      opacity: 0.5;
    }
  }
`;

export const List = styled.ul`
  li + li {
    margin-top: 2.3rem;
  }

  a:hover {
    opacity: 0.5;
  }
`;
